import { render, staticRenderFns } from "./courseWidge.vue?vue&type=template&id=c3eb39ee&scoped=true"
import script from "./courseWidge.vue?vue&type=script&lang=js"
export * from "./courseWidge.vue?vue&type=script&lang=js"
import style0 from "./courseWidge.vue?vue&type=style&index=0&id=c3eb39ee&prod&lang=scss&scoped=true"
import style1 from "./courseWidge.vue?vue&type=style&index=1&id=c3eb39ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3eb39ee",
  null
  
)

export default component.exports